import React, {
  useState,
  useRef,
  useMemo,
  useContext,
  forwardRef,
} from "react";
import "./../styles/HalfBox.css";
import { HeaderTitle } from "./HeaderTitle";
// import { FieldGroup } from "./FieldGroup";
import { TaskDetailsBox } from "./TaskDetailsBox";
import { DecisionBox } from "./DecisionBox";
import SendSelectedText from "../SendSelectedText";
import { Checkbox, FormControlLabel } from "@material-ui/core";
import { useEffect } from "react";
import PdfViewer from "../../pages/PdfViewer";
import { Grid } from "@mui/material";
import { Box } from "@mui/system";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
//import Guidelines from "./Guidelines";
import TableClinical from "./TableClinical";
import { FieldGroupClinical } from "./FieldGroupClinical";
import { Guidelines } from "./Guidelines";
import ClinicalDocDisplay from "./ClinicalDocDisplay";
import axios from "axios";
import { toast } from "react-toastify";
import { DecisionBoxClinical } from "./DecisionBoxClinical";
import { Button } from "@mui/material";
import { ApiCall } from "./../../utility/ApiCalls";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import RichTextBox from "./RichText";
// import PdfDisplay from "./PdfDisplay";
import Modal from "react-modal";
import ReactDOM from "react-dom";
import PopOutModal from "./PopOutModal";
import zIndex from "@mui/material/styles/zIndex";
// import IntelligentCrossValidation from "./IntelligentCrossValidation";
import Api_Call from "../../ApiCall";
import UserContext from "../Common/UserContext";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import { makeStyles } from "@mui/styles";
import { useGuidelines } from "../../pages/GuideLinesProvider";
import Spinner from "./Spinner";
import info from "./../../info.json";
import { error } from "jquery";
import InfoPopup from "./InfoPopup";
import ToolTipClinicalAuditReviewForm from "./ToolTipClinicalAuditReviewForm";
import IntelligentCrossValidation from "./IntelligentCrossValidation2";

const eTYPE = ["form-fields", "document-viewer"];

const useStyles = makeStyles({
  md_response_textarea: {
    width: "100%",
    height: 800,
    overflowY: "auto",
  },
});
export const AIModels = {  
  MISTRAL: "MISTRAL",
  LLAMA: "LLAMA",
};

const RadioStylesAIModels = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  marginRight: "10px",
  gap: "8px",
};

const RadioBtn = forwardRef(
  (
    {
      radioBtn,
      filePATH,
      dataForAIModel,
      setDataForAIModel,
      setLoading,
      isLoading,
      selectedOption,
      setSelectedOption,
      setInitialDecisionValue,
    },
    ref
  ) => {
    console.log(ref);
    const [isOpen, setIsOpen] = useState(false);

    const apiCall = async (endpoint, value) => {
      setLoading(true);

      try {
        const startTime = new Date();
        const api = new Api_Call();
        const data = await api.getData(endpoint);

        const endTime = new Date();
        const timeDifference = (endTime - startTime) / 1000;
        setDataForAIModel((prevValue) => {
          return {
            ...prevValue,
            [value]: {
              ...prevValue[value],
              time: timeDifference.toFixed(1),
            },
          };
        });

        if (data.errorMessage) {
          throw new Error("Some Error Occurred...");
        }

        return data.body;
      } catch (error) {
        console.error("Error fetching data:", error);
        setDataForAIModel((prevValue) => {
          return {
            ...prevValue,
            [value]: {
              ...prevValue[value],
              error: error.message,
            },
          };
        });
        // Handle error state or throw it further
      } finally {
        setLoading(false);
      }
    };

    const handleSelection = async (e, value) => {
      e?.preventDefault();
      const selectedVal = value;

      setSelectedOption(selectedVal);
      if (dataForAIModel[selectedVal]["data"] == null) {
        const data = await apiCall(
          `GENAI/${
            selectedVal == AIModels.GEMINI ? selectedVal : "BEDROCK"
          }?task_ID=${sessionStorage.getItem(
            "ActiveTaskID"
          )}&purpose=clinicalsummary&filename=${filePATH}&model=${selectedVal}`,
          selectedVal
        );

        console.log("-------ai data", data);
        if (data) {
          setInitialDecisionValue(data?.criteria_selectedValue);
        }

        setDataForAIModel((prevValue) => {
          return {
            ...prevValue,
            [selectedVal]: {
              ...prevValue[selectedVal],
              data: data,
              date: new Date(),
            },
          };
        });
      }

      setLoading(false);
      // Update selected option
    };

    const togggleDropdown = (e) => {
      e.preventDefault();
      setIsOpen(!isOpen);
    };
    return (
      <>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            zIndex: "2",
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <span
              style={{
                width: "max-content",
                fontWeight: "700",
              }}
            >
              AI Model:
            </span>

            <div className="dropdown">
              <button
                onClick={(e) => togggleDropdown(e)}
                className="dropbtn"
                style={{ width: "max-content", padding: "7px" }}
              >
                {selectedOption ? selectedOption : "Select"} &#9660;
              </button>
              {isOpen && (
                <div className="dropdown-content" style={{ zIndex: 2 }}>
                  {radioBtn.map((item, index) => (
                    <a
                      href="#"
                      ref={ref[item]}
                      className={`${item}`}
                      onClick={(e) => {
                        console.log("from toggle options");
                        handleSelection(e, item);
                      }}
                    >
                      {item}
                    </a>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
);
export const HalfBoxClinical = (props) => {
  const [loader, setLoader] = useState(true);
  const [confidenceCheck, setConfidenceCheck] = useState(true);
  const [mandatoryCheck, setMandatoryCheck] = useState(false);

  const linkRef = useRef(null);
  const [dataStatus, setDataStatus] = useState(true);
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [showCanvas, setShowCanvas] = useState(false);
  const [selectedField, setSelectedField] = useState("");
  const [callValidateAPI, setCallValidateAPI] = useState(false);
  const [imageDimension, setImageDimension] = useState({ height: 0, width: 0 });
  const [value, setValue] = React.useState(0);
  const [visibility, setVisibility] = useState({
    pdfDoc: "",
    clinicalspdfDoc: "none",
    ncd: "none",
    lcd: "none",
    lca: "none",
    manual: "none",
    policy: "none",
    mcg: "none",
  });
  const [visibility_extractedData, setvisibility_extractedData] = useState({
    intake: "none",
    guidelineSummary: "none",
    clinicalSummary: "none",
    validations: "",
    md_response: "none",
  });
  const [data_value, setDataValue] = React.useState(0);
  const [formcontrol, setFormControl] = useState(true);
  const [tabledata, setTableData] = useState({
    CPTCode_CR: "",
    DescriptionText_CR: "",
    Unit_NR: "",
    AnticipatedStartDate_DT: "",
    AnticipatedEndtDate_DT: "",
  });
  //const [tabledata, setTableData] = useState(null);
  const [updatesummary, setUpdateSummary] = useState("");
  const [updateguidelines, setUpdateGuidelines] = useState("");
  const [guildelinesToUpdate, setGuidelinesToUpdate] = useState("");
  const [summaryToUpdate, setSummaryToUpdate] = useState("");
  const [dataToUpdate, setDataToUpdate] = useState("");
  const [disableStartProcessingBtn, setDisableStartProcessingBtn] =
    useState(false);
  const [validationPerformed, setValidationPerformed] = useState([{}]);
  const [validationPerformedData, setValidationPerformedData] = useState([]);
  const [clinicalNotes, setClinicalNotes] = useState("");
  const [selectedDecisionValue, setSelectedDecisionValue] = useState("");

  const [isValidationPerformed, setIsValidationPerformed] = useState(false);

  const [isModalOpenFilteredGuidelines, setIsModalOpenFilteredGuidelines] =
    useState(false);
  const [isModalOpenClinicalSummary, setIsModalOpenClinicalSummary] =
    useState(false);
  // const [filteredGuidelines,setFilteredGuidelines]=useState(props.guidelines.guideline_summary)
  const [clinicalGuidelines, setClinicalGuidelines] = useState(
    props.guidelines.clinical_summary
  );

  const [filteredGuidelines, setFilteredGuidelines] = useState(
    props.guidelines.guideline_summary
  );

  const [pdfImg, setPdfImg] = useState(props.fax.body.Fax_URL);
  const [pdfURL, setPdfURL] = useState(props.fax.body.Fax_PDF_URL);
  const [filename, setfilename] = useState(props.fax.body.Fax_PDF_URL);
  const [filepath, setfilepath] = useState();
  const { userId } = useContext(UserContext);
  const [newEntry, setNewEntry] = useState([]);
  const [mdResponse, setMdResponse] = useState("");
  const [clinicalRationale, setClinicalRationale] = useState("");
  const [mdResponseStatus, setMdResponseStatus] = useState("");
  const [mdResponseValue, setMdResponseValue] = useState("");
  const [mdResponseDate, setMdResponseDate] = useState("");
  const [mdoutcome, setMdOutcome] = useState("");
  const [initalDecisonvalue, setInitialDecisionValue] = useState(
    props.ocrData.SelectedValue
  );

  const [loadingGenAI, setLoadingGenAI] = useState(false);
  const refsForModels = {
    GEMINI: useRef(null),
    MISTRAL: useRef(null),
    LLAMA: useRef(null),
  };

  console.log(refsForModels);
  const [dataForAIModel, setDataForAIModel] = useState(() => {
    const newObj = {};
    Object.keys(AIModels).forEach(
      (item) =>
        (newObj[item] = {
          data: null,
          time: 0,
          error: null,
          date: null,
        })
    );

    return newObj;
  });

  console.log(dataForAIModel);

  const [selectedOption, setSelectedOption] = useState("");
  const [isYesPressedInError, setIsYesPressedInError] = useState(false);

  console.log(dataForAIModel[selectedOption]?.["error"]);

  useEffect(() => {
    const urlParts = filename.split("/");

    // Get the last part of the array which should be the filename
    const filenameWithParams = urlParts[urlParts.length - 1];

    // Remove any parameters after the filename
    const filePATH = filenameWithParams.split("?")[0];
    setfilepath(filePATH);
  }, []);
  console.log(
    "initalDecisonvalue",
    initalDecisonvalue,
    props.ocrData.SelectedValue
  );

  const handleChangeDoc = (event, newValue) => {
    setVisibility({
      pdfDoc: "none",
      clinicalspdfDoc: "none",
      ncd: "none",
      lcd: "none",
      lca: "none",
      manual: "none",
      policy: "none",
      mcg: "none",
    });
    setValue(newValue);
  };

  const handleChangeData = (event, newData) => {
    setvisibility_extractedData({
      intake: "none",
      guidelineSummary: "none",
      validations: "none",
    });
    setDataValue(newData);
  };

  function LinkTab(props) {
    return (
      <Tab
        style={{
          color: "#f5642d",
          paddingLeft: "0.8rem",
          paddingRight: "0.8rem",
        }}
        component="a"
        onClick={(event) => {
          event.preventDefault();
          if (props.show === "pdfDoc") {
            setVisibility({
              pdfDoc: "",
              clinicalspdfDoc: "none",
              ncd: "none",
              lcd: "none",
              lca: "none",
              manual: "none",
              policy: "none",
              mcg: "none",
            });
          } else if (props.show === "clinicalspdfDoc") {
            setVisibility({
              pdfDoc: "none",
              clinicalspdfDoc: "",
              ncd: "none",
              lcd: "none",
              lca: "none",
              manual: "none",
              policy: "none",
              mcg: "none",
            });
          } else if (props.show === "ncd") {
            setVisibility({
              pdfDoc: "none",
              clinicalspdfDoc: "none",
              ncd: "",
              lcd: "none",
              lca: "none",
              manual: "none",
              policy: "none",
              mcg: "none",
            });
          } else if (props.show === "lcd") {
            setVisibility({
              pdfDoc: "none",
              clinicalspdfDoc: "none",
              ncd: "none",
              lcd: "",
              lca: "none",
              manual: "none",
              policy: "none",
              mcg: "none",
            });
          } else if (props.show === "lca") {
            setVisibility({
              pdfDoc: "none",
              clinicalspdfDoc: "none",
              ncd: "none",
              lcd: "none",
              lca: "",
              manual: "none",
              policy: "none",
              mcg: "none",
            });
          } else if (props.show === "manual") {
            setVisibility({
              pdfDoc: "none",
              clinicalspdfDoc: "none",
              ncd: "none",
              lcd: "none",
              lca: "none",
              manual: "",
              policy: "none",
              mcg: "none",
            });
          } else if (props.show === "policy") {
            setVisibility({
              pdfDoc: "none",
              clinicalspdfDoc: "none",
              ncd: "none",
              lcd: "none",
              lca: "none",
              manual: "none",
              policy: "",
              mcg: "none",
            });
          } else {
            setVisibility({
              pdfDoc: "none",
              clinicalspdfDoc: "none",
              ncd: "none",
              lcd: "none",
              lca: "none",
              manual: "none",
              policy: "none",
              mcg: "",
            });
          }
        }}
        {...props}
      />
    );
  }

  function LinkTabData(props) {
    return (
      <Tab
        style={{
          color: "#f5642d",
          paddingLeft: "0.8rem",
          paddingRight: "0.8rem",
        }}
        component="b"
        onClick={(event) => {
          event.preventDefault();
          if (props.show === "validations") {
            setvisibility_extractedData({
              intake: "none",
              guidelineSummary: "none",
              validations: "",
              md_response: "none",
            });
            validationPerformedApi();
          } else if (props.show === "guidelines") {
            setvisibility_extractedData({
              intake: "none",
              guidelineSummary: "",
              validations: "none",
              md_response: "none",
            });
          } else if (props.show === "intake") {
            setvisibility_extractedData({
              intake: "",
              guidelineSummary: "none",
              validations: "none",
              md_response: "none",
            });
          } else if (props.show === "md_response") {
            setvisibility_extractedData({
              intake: "none",
              guidelineSummary: "none",
              validations: "none",
              md_response: "",
            });
          }
        }}
        {...props}
      />
    );
  }

  // const memoizedFilteredGuidelines=useMemo(()=>props.guidelines.guideline_summary,[props.guidelines.guideline_summary])

  // useEffect(()=>{
  //   console.log(props.guidelines.guideline_summary)

  //   if(props.guidelines.guideline_summary)
  //   {
  //      console.log(props.guidelines.guideline_summary)
  //      setFilteredGuidelines(props.guidelines.guideline_summary)
  //   }
  // },[memoizedFilteredGuidelines])

  useEffect(() => {
    // Your logic to update filteredGuidelines
    // For demonstration, let's set it directly
    console.log("setting context");
    setFilteredGuidelines(props.guidelines.guideline_summary);
    console.log("<<<<>>>>>>", props.ocrData.SelectedValue);
  }, []);

  console.log(selectedDecisionValue);

  useEffect(() => {
    // setGuidelinesToUpdate(props.guidelines.guideline_summary);
    // setSummaryToUpdate(props.guidelines.clinical_summary);
    setStates();
    validationPerformedApi();
    setTimeout(() => {
      setLoader(false);
    }, 5000);
  }, []);

  function setStates() {
    console.log("setting state in half box ");
    setGuidelinesToUpdate(props.guidelines.guideline_summary);
    setSummaryToUpdate(props.guidelines.clinical_summary);

    // console.log('selected value ',props.ocrData.SelectedValue);
    setSelectedDecisionValue(props.ocrData.SelectedValue);
  }

  useEffect(() => {
    if (info.MD_RESPONSE) mdResponseFunction();
  }, []);
  // useEffect(() => {
  //   setGuidelinesToUpdate(props.guidelines.guideline_summary);
  //   setSummaryToUpdate(props.guidelines.clinical_summary);
  //   setTimeout(() => {
  //     setLoader(false);
  //   }, 5000);
  //   console.log('Guidelines state in useEffect ', guildelinesToUpdate);
  //   console.log('Summary state in useEffect ', summaryToUpdate);
  // }, []);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  const getHeightAndWidthOfElement = (elementId) => {
    let element = document.getElementById(elementId);
    if (!element) {
      return {
        width: 0,
        height: 0,
      };
    }
    return {
      width: element.getBoundingClientRect().width,
      height: element.getBoundingClientRect().height,
    };
  };

  const confidenceChecked = (e) => {
    const checked = e.target.checked;
    if (checked) {
      setConfidenceCheck(true);
    } else {
      setConfidenceCheck(false);
    }
  };

  const mandatoryChecked = (e) => {
    const checked = e.target.checked;
    if (checked) {
      setMandatoryCheck(true);
    } else {
      setMandatoryCheck(false);
    }
  };

  async function create_data(blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      // If error occurs, reject the promise
      reader.onerror = reject;
      // Define an onload handler that's called when file loaded
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.readAsDataURL(blob);
    });
  }

  async function updateGuidelines(data) {
    let blob = new Blob([data.target.value], { type: "plain/text" });
    const base64String = await create_data(blob);
    var new_base64 = base64String.split(",")[1];
    setDataToUpdate(new_base64);
    // console.log('value updated ', dataToUpdate);
  }

  async function updateSummary(data) {
    let blob = new Blob([data.target.value], { type: "plain/text" });
    const base64String = await create_data(blob);
    var new_base64 = base64String.split(",")[1];
    setDataToUpdate(new_base64);
  }

  async function updateClinicalNotes(data) {
    setClinicalNotes(data.target.value);
  }

  async function SaveUpdatedNotes(e) {
    // console.log(document.getElementById(`${props.txtId}`).innerText);
    console.log(e.target.value, e.target.name);
    console.log(e.target.defaultValue);
    if (e.target.value != e.target.defaultValue) {
      const api = new Api_Call();
      const data = await api.putData("FAX/UPDATE-FIELD", {
        userId: userId,
        taskId: sessionStorage.getItem("ActiveTaskID"),
        fieldName: e.target.name,
        newValue: e.target.value,
        op_type: "update",
      });
      toast.success(data.body);

      // const ret = await ApiCall(
      // {
      //     userId: "1",
      //     taskId: sessionStorage.getItem("ActiveTaskID"),
      //     fieldName: e.target.name,
      //     newValue: e.target.value,
      //     op_type: "update"
      // },
      // "vcare-ui",
      // "vcare_updatefield"
      // );
      // toast.success(ret.body);
    }
  }

  const updateClinicalValue = async (data, hanger) => {
    setDisableStartProcessingBtn(true);
    //console.log('Value of state ', dataToUpdate);
    const url =
      "https://tokcfhkksh.execute-api.us-east-1.amazonaws.com/Dev/vcare_clinicaldataupdate";
    //const url = "https://63japqerd7.execute-api.us-east-1.amazonaws.com/Dev/zone2_vcare_clinicaldataupdate";
    //const url = "";
    //setDataToUpdate((data.target.value).replace(/(^[ \t]*\n)/gm, ""));
    //console.log('converted data in update ', btoa(data.target.value));
    /* Convert string to blob and b64 */
    //let blob = new Blob([data.target.value], { type : 'plain/text' });
    // var reader = new FileReader();
    // reader.readAsDataURL(blob);
    // var b64 = "";
    //const base64String = await create_data(blob);
    // reader.onloadend = function() {
    //   var base64data = reader.result;
    //   // console.log(base64data.split(",")[1]);
    //   b64 = base64data.split(",")[1];
    //   console.log('parsed base 64 ', b64);
    //   setDataToUpdate(b64);
    // }
    //console.log('data received ', base64String);
    //var new_base64 = base64String.split(",")[1];
    console.log("hanger in update ", hanger);
    console.log("value to be sent ", dataToUpdate);
    if (dataToUpdate === "") {
      toast.success("Data remains unchanged", { autoClose: true });
    } else {
      try {
        const api = new Api_Call();
        const data = await api.putData("CLINICAL-REVIEW/UPDATE-DATA", {
          taskID: props.ocrData.Task_ID,
          hanger: hanger,
          clinical_data: dataToUpdate,
        });
        let isStatus = data.headers.success;
        console.log(isStatus);
        if (isStatus === true) {
          toast.success(data.body, { autoClose: true });
        } else {
          toast.error(data.body, { autoClose: true });
        }
      } catch (error) {
        console.log(error);
      }

      // axios
      //   .post(url, {
      //     taskID: props.ocrData.Task_ID,
      //     hanger: hanger,
      //     clinical_data: dataToUpdate,
      //   })
      //   .then((response) => {
      //     console.log(response);
      //     let isStatus = response.data.headers.success;
      //     console.log(isStatus);
      //     if (isStatus === true) {
      //       toast.success(response.data.body, { autoClose: true });
      //     } else {
      //       toast.error(response.data.body, { autoClose: true });
      //     }
      //   })
      //   .catch((error) => {
      //     console.log(error);
      //   });
    }
  };

  const mdResponseFunction = async () => {
    try {
      const api = new Api_Call();
      const data = await api.getData(`CLINICAL-REVIEW/MD-RESPONSE?taskID=1`);
      if (data.statusCode != 200) {
        throw new Error("Error Fetching Data");
      }

      setMdResponse(data.body["MD_Response"][0]["MD Response"]);
      setClinicalRationale(data.body["MD_Response"][0]["Clinical Rationale"]);
      setMdResponseStatus(data.body["MD_Response"][0]["MD Response Status"]);
      setMdResponseValue(data.body["MD_Response"][0]["Reason"]);
      setMdResponseDate(data.body["MD_Response"][0]["Response Date"]);
      setMdOutcome(data.body["MD_Response"][0]["Outcome"]);
    } catch (error) {
      console.log(error.message);
    }
  };

  async function validationPerformedApi() {
    console.log("calling the API for getting validations");

    const api = new Api_Call();
    const data = await api.getData(
      `CLINICAL-REVIEW/VALIDATIONS?taskID=${sessionStorage.getItem(
        "ActiveTaskID"
      )}`
    );

    const response = data.body;
    console.log("response from API ", response);
    if (response) {
      setValidationPerformedData(response);
    }
    setIsValidationPerformed(true);

    // const ret = await ApiCall(
    //   {
    //     taskID: window.sessionStorage.getItem("ActiveTaskID"),
    //   },
    //   "vcare-ui",
    //   "vcareui_clinicalvalidations"
    // );
    // const response = ret.body;
    // console.log("response from API ", response);
    // if (response) {
    //   setValidationPerformedData(response);
    // }
    // setIsValidationPerformed(true);
  }

  function handleBodyClick(e) {
    //e.preventDefault();
    var activeElement = document.activeElement;
    console.log(document.activeElement.className);
    var inputs = [
      "txtMemberID_CR",
      "txtDateOfBirth_DT",
      "txtFirstName_CR",
      "txtLastName_CR",
      "txtRequestorName_CR",
      "txtRequestorContactNo_CR",
      "txtRequestorFaxNo_CR",
      "txtAdditionalMessage_CR",
      "txttxtServiceRequestDate_DT",
      "txtAnticipatedStart",
      "txttxtAnticipatedEnd",
      "txtAnticipatedStartDate_DT",
    ];

    if (activeElement && inputs.indexOf(activeElement.id) !== -1) {
      return;
    }

    var result = document.getElementById("myresult");
    var lens = document.getElementById("highlightbox");
    result.style.display = "none";
    lens.style.display = "none";
    return;
  }

  console.log("------------------------------------------->", dataForAIModel);

  const sendRefreshRequest = () => {
    refsForModels[selectedOption].current?.click();
    setDataForAIModel((prevValue) => {
      return {
        ...prevValue,
        [selectedOption]: {
          ...prevValue[selectedOption],
          error: null,
        },
      };
    });
  };

  const renderRichText = () => {
    return (
      <RichTextBox
        isOpen={isModalOpenClinicalSummary}
        hanger={"Clinical Summary"}
        onClose={() => {
          setIsModalOpenClinicalSummary(false);
        }}
        text={
          dataForAIModel[selectedOption] == undefined
            ? clinicalGuidelines
            : dataForAIModel[selectedOption]?.["data"]?.rtf
        }
        setText={(value) =>
          dataForAIModel[selectedOption] == undefined
            ? setClinicalGuidelines(value)
            : setDataForAIModel((prevValue) => {
                return {
                  ...prevValue,
                  [selectedOption]: {
                    ...prevValue[selectedOption],
                    data: dataForAIModel[selectedOption]?.["data"],
                  },
                };
              })
        }
      >
        {/* text={props.guidelines.clinical_summary} */}
        text={dataForAIModel[selectedOption]?.["data"]?.rtf}
        taskStatus={props.taskStatus}
        hanger={"Clinical Summary"}
        taskID={props.ocrData.Task_ID}
      </RichTextBox>
    );
  };
  return (
    <>
      {loadingGenAI && (
        <Box className="loader-wrapper">
          <div className="loader"></div>
        </Box>
      )}
      <Grid container spacing={2}>
        <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
          <TaskDetailsBox
            taskData={props.taskData}
            ocrData={props.ocrData}
            taskStatus={props.taskStatus}
            authId={props.authId}
          ></TaskDetailsBox>
        </Grid>
        <Grid item xl={7} lg={7} md={7} sm={12} xs={12} className="flexbox-h6">
          <div class="left-box-container">
            {/* {loader ? (
              <Box className="loader-wrapper loader-fax-wrapper">
                <div className="loader"></div>
              </Box>
            ) : (
              ""
            )} */}
            <Box sx={{ width: "100%" }}>
              <Tabs
                value={value}
                onChange={handleChangeDoc}
                aria-label="nav tabs example"
                variant="standard"
              >
                <LinkTab label="Fax Form" show="pdfDoc" />
                <LinkTab label="Clinicals" show="clinicalspdfDoc" />
                {/* <LinkTab label="NCD" show="ncd" /> */}
                {/* <LinkTab label="LCD" show="lcd" /> */}
                {/* <LinkTab label="LCA" show="lca" />
                <LinkTab label="Benefit Manual" show="manual"  variant="standard" />
                <LinkTab label="Client Policy" show="policy"  variant="standard" /> */}
                <LinkTab label="Clinical Guideline" show="mcg" />
              </Tabs>
            </Box>
            <Guidelines
              display={visibility.mcg}
              text={props.guidelines.MCG}
              value="MCG"
            />
            <Guidelines
              display={visibility.lcd}
              text={props.guidelines.LCD}
              value="LCD"
            />
            <FieldGroupClinical
              newEntry={newEntry}
              setNewEntry={setNewEntry}
              contentType="fields"
              fieldGroup="pdf_box"
              // pdfImg={props.fax.body.Fax_URL}
              // pdfUrl={props.fax.body.Fax_PDF_URL}
              pdfImg={pdfImg}
              pdfUrl={pdfURL}
              setShowCanvas={setShowCanvas}
              showCanvas={showCanvas}
              selectedField={selectedField}
              setCallValidateAPI={setCallValidateAPI}
              getOCRDatafromAPI={props.getOCRDatafromAPI}
              imageDimension={imageDimension}
              setImageDimension={setImageDimension}
              display={visibility.pdfDoc}
            ></FieldGroupClinical>
            <ClinicalDocDisplay
              style={{ display: visibility.clinicalspdfDoc }}
              src={props.fax.body.Clinical_PDF_URL}
            ></ClinicalDocDisplay>
          </div>
        </Grid>
        <Grid item xl={5} lg={5} md={5} sm={12} xs={12} className="flexbox-h6">
          <Box sx={{ width: "100%" }}>
            <Tabs
              value={data_value}
              onChange={handleChangeData}
              aria-label="nav tabs example"
              variant="standard"
            >
              <LinkTabData label="Validations" show="validations" />
              <LinkTabData label="Clinical Review" show="guidelines" />
              <LinkTabData label="Intake Data" show="intake" />
              {info.MD_RESPONSE && (
                <LinkTabData label="MD Response" show="md_response" />
              )}
            </Tabs>
          </Box>
          <div
            className="box-half"
            style={{ display: visibility_extractedData.guidelineSummary }}
          >
            <div className="halfbox-content-new">
              <form>
                <div className="box-content">
                  <div className="header-content-popup">
                    <HeaderTitle
                      divStyle="header-div--sub"
                      headerStyle="header--sub"
                      headerColor="header--color"
                      headerSize="header--small"
                      divAlign="header--left"
                      textContent="Filtered Guidelines"
                    ></HeaderTitle>
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        setIsModalOpenFilteredGuidelines(true);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <i className="fa fa-external-link-alt"></i>
                    </button>
                  </div>
                  {/* <h4>{guildelinesToUpdate} </h4> */}
                  {/* <RichTextBox text={filteredGuidelines} setText={setFilteredGuidelines}> */}
                  <RichTextBox
                    text={filteredGuidelines}
                    setText={setFilteredGuidelines}
                    type="BackGround"
                    hanger={"Summary"}
                  >
                    {/* text={filteredGuidelines} */}
                    id={props.ocrData.Task_ID}
                    taskStatus={props.taskStatus}
                    hanger={"Summary"}
                    taskID={props.ocrData.Task_ID}
                  </RichTextBox>
                  {/* <Guidelines
                    txtId="filteredguidelines"
                    display={visibility_extractedData.guidelineSummary} 
                    text={guildelinesToUpdate}
                    updatedtext={updateGuidelines}
                    taskStatus={props.taskStatus}
                    // updateField={e => updateClinicalValue(e, "Summary")}
                    // updateField={(e) => updateClinicalValue(e, "Summary")}
                    value="filtered"/>  */}
                </div>
                {/* <div style={{textAlign: "right"}}>
                    {props.taskStatus != 7 && props.taskStatus != 8 && props.taskStatus != 9 ? ( <>
                    <Button
                      // buttonStyle={
                      //   disableStartProcessingBtn ? "btn--disabled" : "btn--outline"
                      // }
                      onClick={(e) => updateClinicalValue(e, "Summary")}
                      // disabled={disableStartProcessingBtn}
                    >
                    Save
                  </Button> 
                  <Button buttonStyle="btn--outline" type="reset" >
                    Revert
                  </Button> </>
                    ) : ("")}
                </div> */}
              </form>
              {/* <button onClick={()=>{setIsModalOpenClinicalSummary(true)}}></button> */}
              <form>
                <div className="box-content">
                  <div className="header-content-popup">
                    <HeaderTitle
                      divStyle="header-div--sub"
                      headerStyle="header--sub"
                      headerSize="header--small"
                      headerColor="header--color"
                      divAlign="header--left"
                      textContent="Clinical Summary"
                      // style={{ marginRight: 'auto' }}
                    />

                    <RadioBtn
                      radioBtn={[
                        ...Object.keys(AIModels).map((item) => {
                          console.log(item);
                          return AIModels[item];
                        }),
                      ]}
                      ref={refsForModels}
                      isYesPressed={isYesPressedInError}
                      setYesPressed={setIsYesPressedInError}
                      isLoading={loadingGenAI}
                      setLoading={setLoadingGenAI}
                      filePATH={filepath}
                      dataForAIModel={dataForAIModel}
                      setDataForAIModel={setDataForAIModel}
                      selectedOption={selectedOption}
                      setInitialDecisionValue={setInitialDecisionValue}
                      setSelectedOption={setSelectedOption}
                    ></RadioBtn>
                    <ToolTipClinicalAuditReviewForm
                      widthTo="300px"
                      information={`
                        <p style="font-size:16px;font-weight:400;">
                          Model Name: ${
                            selectedOption
                              ? selectedOption
                              : "Please Select Modal"
                          }
                        </p>
                        <p style="font-size:16px;font-weight:400;">
                          Response Time: ${
                            dataForAIModel[selectedOption]?.time
                              ? `${dataForAIModel[selectedOption]?.time} sec`
                              : "0 sec"
                          }
                        </p>
                      
                      `}
                      pos={"static"}
                    ></ToolTipClinicalAuditReviewForm>
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        setIsModalOpenClinicalSummary(true);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <i className="fa fa-external-link-alt"></i>
                    </button>
                  </div>
                  {dataForAIModel[selectedOption]?.["error"] != null && (
                    <div className="error-message-ai">
                      Some Error Occured Please{" "}
                      <a
                        href="#"
                        onClick={() => {
                          sendRefreshRequest();
                        }}
                      >
                        Try Again
                      </a>
                    </div>
                  )}
                  {/* <h4>{summaryToUpdate} </h4> */}
                  {/* <RichTextBox
                    text={clinicalGuidelines}
                    setText={setClinicalGuidelines}
                    type="BackGround"
                  > */}
                  {/* text={clinicalSummary} */}
                  {/* taskStatus={props.taskStatus}
                    hanger={"Clinical Summary"}
                    taskID={props.ocrData.Task_ID}
                  </RichTextBox> */}

                  {renderRichText()}
                  {/* <Guidelines 
                    txtId="clinicalsummary"
                    display={visibility_extractedData.guidelineSummary} 
                    text={summaryToUpdate}
                    updatesummary={updateSummary}
                    taskStatus={props.taskStatus}
                    //updateField={e => updateClinicalValue(e, "Clinical Summary")}
                    // updateField={(e) => updateClinicalValue(e, "Summary")}
                    value="clinical"/> */}
                </div>
                {/* <div style={{textAlign: "right"}}>
                  {props.taskStatus != 7 && props.taskStatus != 8 && props.taskStatus != 9 ? ( <>
                  <Button buttonStyle="btn--outline" onClick={(e) => updateClinicalValue(e, "Clinical Summary")} >
                    Save
                  </Button>
                  <Button buttonStyle="btn--outline" type="reset" >
                    Revert
                  </Button> </>
                   ) : ( "" )} 
                </div> */}
              </form>
              <IntelligentCrossValidation
                model={selectedOption}
                filepath={filepath}
              />
              <div className="box-content">
                <HeaderTitle
                  divStyle="header-div--sub"
                  headerStyle="header--sub"
                  headerSize="header--small"
                  headerColor="header--color"
                  divAlign="header--left"
                  textContent="Decision Line"
                ></HeaderTitle>
                <TableClinical
                  taskStatus={props.taskStatus}
                  criteriaMet={props.criteriaMet}
                  cptData={props.cptData}
                  setCPTData={props.setCPTData}
                  selectedValue={selectedDecisionValue}
                  onSelect={setSelectedDecisionValue}
                  initalDecisonvalue={initalDecisonvalue}
                ></TableClinical>
              </div>
              {/* <Guidelines display={visibility_extractedData.guidelineSummary} text="" value="decision"/> */}
              <div></div>
              <form>
                <div className="box-content">
                  {/* {data_value===2 &&<HeaderTitle
                  divStyle="header-div--sub"
                  headerStyle="header--sub"
                  headerSize="header--medium"
                  divAlign="header--left"
                  textContent="Comments"
                ></HeaderTitle>} */}
                  {/* <Guidelines 
                    txtId="intakenotes"
                    display={visibility_extractedData.guidelineSummary} 
                    text={props.ocrData.IntakeNotes}
                    taskStatus={props.taskStatus}
                    value="IntakeNotes"/> */}
                  {/* <Guidelines 
                    txtId="ClinicalNotes_CR"
                    display={visibility_extractedData.guidelineSummary} 
                    text={props.ocrData.ClinicalNotes}
                    updateClinicalNotes={updateClinicalNotes}
                    taskStatus={props.taskStatus}
                    SaveUpdatedNotes={e => SaveUpdatedNotes(e)}  
                    value="ClinicalNotes" /> */}
                  {/* <div style={{textAlign: "right", display: "flex"}}>
                      {props.taskStatus != 7 && props.taskStatus != 8 && props.taskStatus != 9 ? ( <>
                        <Button buttonStyle="btn--outline" onClick={(e) => SaveUpdatedNotes()} >
                            Save
                        </Button>
                        <Button buttonStyle="btn--outline" type="reset" >
                            Revert
                        </Button> </>
                      ) : ( "" )} 
                    </div> */}
                </div>
              </form>
            </div>
          </div>

          <div
            className="box-half"
            style={{ display: visibility_extractedData.validations }}
          >
            <Box className="validation-performed-content">
              <Box className="validation-performed">
                <ul>
                  {validationPerformedData
                    ? validationPerformedData.map(
                        (val) => (
                          // val.log_type == 1 ? (
                          <li key={val}>
                            <span>
                              <CheckCircleOutlinedIcon className="success" />
                            </span>{" "}
                            <span>
                              <b>{val.Title}:</b>
                              <p style={{ marginBottom: "5px" }} />
                              <ul>
                                {val.ATTRIBS.map((attrib) => (
                                  <li>
                                    {attrib.KEY} {attrib.VALUE}
                                  </li>
                                ))}
                              </ul>
                            </span>
                          </li>
                        )
                        // ) : (
                        //   <li>
                        //     <span>
                        //       <HighlightOffIcon className="error" />
                        //     </span>{" "}
                        //     <span>{val.Activity_CR}</span>
                        //   </li>
                        // )
                      )
                    : ""}
                </ul>
              </Box>
            </Box>
            <form>
              {/* <div>
                {data_value===2  && <HeaderTitle
                  divStyle="header-div--sub"
                  headerStyle="header--sub"
                  headerSize="header--small"
                  divAlign="header--left"
                  textContent="Comments"
                ></HeaderTitle> }</div>  */}
              <div>
                {/* <Guidelines 
                    txtId="intakenotes"
                    display={visibility_extractedData.validations} 
                    text={props.ocrData.IntakeNotes}
                    taskStatus={props.taskStatus}
                    value="IntakeNotes"/> */}
                <Guidelines
                  // optionWeSelectedInHeaderValidCRID={data_value}
                  txtId="ClinicalNotes_CR"
                  display={visibility_extractedData.validations}
                  text={props.ocrData.ClinicalNotes}
                  updateClinicalNotes={updateClinicalNotes}
                  taskStatus={props.taskStatus}
                  value="ClinicalNotes"
                  SaveUpdatedNotes={(e) => SaveUpdatedNotes(e)}
                />
                {/* <div style={{textAlign: "right"}}>
                    {props.taskStatus != 7 && props.taskStatus != 8 && props.taskStatus != 9 ? ( <>
                    <Button buttonStyle="btn--outline" onClick={(e) => SaveUpdatedNotes(e)} >
                      Save
                    </Button>
                    <Button buttonStyle="btn--outline" type="reset" >
                      Revert
                    </Button> </>
                    ) : ( "" )} 
                  </div> */}
              </div>
            </form>
          </div>

          <div
            className="box-half"
            style={{ display: visibility_extractedData.intake }}
          >
            <Box className="halfbox-checkbox-wrapper">
              <div className="box-header">
                <HeaderTitle
                  divStyle="header-div--sub"
                  headerStyle="header--sub"
                  headerSize="header--small"
                  headerColor="header--color"
                  divAlign="header--left"
                  textContent="Extracted Data"
                ></HeaderTitle>
              </div>
              <FormControlLabel
                className="confidence-checkbox-box"
                control={
                  <Checkbox
                    // defaultChecked
                    size="small"
                    onClick={(e) => mandatoryChecked(e)}
                  />
                }
                label="Show Optional Fields"
              />
              <FormControlLabel
                className="confidence-checkbox-box"
                control={
                  <Checkbox
                    defaultChecked
                    size="small"
                    onClick={(e) => confidenceChecked(e)}
                  />
                }
                // label="Show Confidence Level"
                label="Show Completion Status"
              />
            </Box>
          </div>

          {info.MD_RESPONSE && (
            <div
              className="box-half"
              style={{ display: visibility_extractedData.md_response }}
            >
              <div className="halfbox-content-new">
                <div className="box-content" style={{ maxHeight: "800px" }}>
                  <div
                    style={{
                      textAlign: "end",
                      width: "100%",
                      position: "relative",
                      marginBottom: "50px",
                    }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        right: "0",
                        width: "fit-content",
                        marginBottom: "20px",
                        fontSize: "14px",
                      }}
                    >
                      <div
                        style={{
                          marginBottom: "10px",
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <span style={{ fontWeight: "bold" }}>
                          MD Response Date and Time:
                        </span>
                        <span style={{ marginLeft: "5px" }}>
                          {" "}
                          {mdResponseDate}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div style={{ marginBottom: "20px", width: "100%" }}>
                    <div style={{ marginBottom: "5px", fontWeight: "bold" }}>
                      MD Response Status
                    </div>
                    {/* <input
                    type="text"
                    readOnly
                    style={{ width: "100%", height: "30px", padding: "5px" }}
                    value={mdResponseStatus}
                  /> */}
                    <p
                      style={{ width: "100%", height: "30px", padding: "5px" }}
                    >
                      {mdResponseStatus}
                    </p>
                  </div>

                  <div style={{ marginBottom: "20px", width: "100%" }}>
                    <div style={{ marginBottom: "5px", fontWeight: "bold" }}>
                      MD Response Value
                    </div>
                    {/* <input
                    type="text"
                    value={mdResponseValue}
                    readOnly
                    style={{ width: "100%", height: "30px", padding: "5px" }}
                  /> */}
                    <p
                      style={{ width: "100%", height: "30px", padding: "5px" }}
                    >
                      {" "}
                      {mdResponseValue}
                    </p>
                  </div>

                  <div style={{ marginBottom: "20px", width: "100%" }}>
                    <div style={{ marginBottom: "5px", fontWeight: "bold" }}>
                      Outcome
                    </div>
                    {/* <input
                    type="text"
                    value={mdResponseValue}
                    readOnly
                    style={{ width: "100%", height: "30px", padding: "5px" }}
                  /> */}
                    <p
                      style={{ width: "100%", height: "30px", padding: "5px" }}
                    >
                      {" "}
                      {mdoutcome}
                    </p>
                  </div>

                  <div style={{ marginBottom: "20px", width: "100%" }}>
                    <div style={{ marginBottom: "5px", fontWeight: "bold" }}>
                      MD Response
                    </div>
                    {/* <TextareaAutosize
                    aria-label="md-response"
                    style={{
                      width: "100%",
                      height: "180px",
                      overflow: "auto",
                      resize: "none",
                      padding: "5px",
                      padding: "5px",
                    }}
                    readOnly
                    value={mdResponse}
                  ></TextareaAutosize> */}
                    <p
                      style={{
                        width: "100%",
                        height: "180px",
                        overflow: "auto",
                        resize: "none",
                        padding: "5px",
                        padding: "5px",
                      }}
                    >
                      {mdResponse}
                    </p>
                  </div>

                  <div style={{ marginBottom: "20px", width: "100%" }}>
                    <div style={{ marginBottom: "5px", fontWeight: "bold" }}>
                      Clinical Rationale
                    </div>
                    {/* <TextareaAutosize
                    aria-label="md-clinical-rationale"
                    style={{
                      width: "100%",
                      height: "180px",
                      overflow: "auto",
                      resize: "none",
                      padding: "5px",
                    }}
                    readOnly
                    value={clinicalRationale}
                  ></TextareaAutosize> */}
                    <p
                      style={{
                        width: "100%",
                        height: "180px",
                        overflow: "auto",
                        resize: "none",
                        padding: "5px",
                      }}
                    >
                      {clinicalRationale}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* <SendSelectedText /> */}
          <div
            className="halfbox-content-new"
            onClick={handleBodyClick}
            style={{
              display: visibility_extractedData.md_response == "" && "none",
            }}
          >
            <div className="box-content">
              <FieldGroupClinical
                newEntry={newEntry}
                setNewEntry={setNewEntry}
                contentType="fields"
                headerTitle="Validation"
                fieldGroup="validation"
                ocrData={props.ocrData}
                confidenceCheck={confidenceCheck}
                display={visibility_extractedData.intake}
              ></FieldGroupClinical>
              <FieldGroupClinical
                newEntry={newEntry}
                setNewEntry={setNewEntry}
                contentType="fields"
                // headerTitle="Member Information"
                fieldGroup="common_information"
                pdfImg={props.fax.body.Fax_URL}
                ocrData={props.ocrData}
                coords={props.coords}
                setterMethod={props.setOCRData}
                confidenceCheck={confidenceCheck}
                dxData={props.dxData}
                setDXData={props.setDXData}
                cptData={props.cptData}
                setCPTData={props.setCPTData}
                umReviewTypeCB={props.umReviewTypeCB}
                admissionSourceCB={props.admissionSourceCB}
                requestProfileCB={props.requestProfileCB}
                admissionTypeCB={props.admissionTypeCB}
                selectedUMreviewType={props.selectedUMreviewType}
                setUMReviewTypeSelected={props.setUMReviewTypeSelected}
                selectedAdmissionSource={props.selectedAdmissionSource}
                setAdmissionSourceSelected={props.setAdmissionSourceSelected}
                selectedAdmissionType={props.selectedAdmissionType}
                setAdmissionTypeSelected={props.setAdmissionTypeSelected}
                selectedRequestProfile={props.selectedRequestProfile}
                setSelectedRequestProfile={props.setSelectedRequestProfile}
                selectedUMReviewTypeData={props.selectedUMReviewTypeData}
                requestProfileData={props.requestProfileData}
                providerData={props.providerData}
                setProviderData={props.setProviderData}
                mandatoryCheck={mandatoryCheck}
                taskStatus={props.taskStatus}
                getOCRDatafromAPI={props.getOCRDatafromAPI}
                setDataStatus={setDataStatus}
                setShowCanvas={setShowCanvas}
                setSelectedField={setSelectedField}
                imageDimension={imageDimension}
                setImageDimension={setImageDimension}
                display={visibility_extractedData.intake}
                maxConfidence={props.ocrData.Confidence}
              ></FieldGroupClinical>
            </div>
            <div className="box-footer">
              <DecisionBoxClinical
                ocrData={props.ocrData}
                taskData={props.taskData}
                selectedUMreviewType={props.selectedUMreviewType}
                selectedAdmissionSource={props.selectedAdmissionSource}
                selectedAdmissionType={props.selectedAdmissionType}
                selectedRequestProfile={props.selectedRequestProfile}
                dxData={props.dxData}
                cptData={props.cptData}
                providerData={props.providerData}
                isLoading={props.isLoading}
                setLoading={props.setLoading}
                taskStatus={props.taskStatus}
                completedTime={props.completedTime}
                getOCRDatafromAPI={props.getOCRDatafromAPI}
                dataStatus={dataStatus}
                display={visibility_extractedData.intake}
                notDisplay={visibility_extractedData.md_response}
                tabDetail={visibility_extractedData}
                selectedDecisionValue={selectedDecisionValue}
              ></DecisionBoxClinical>
            </div>
          </div>
          {/* </div> */}
        </Grid>
      </Grid>
      <PopOutModal
        isOpen={isModalOpenFilteredGuidelines}
        onClose={() => {
          setIsModalOpenFilteredGuidelines(false);
        }}
        content={
          <div className="halfbox-content-new">
            <form>
              <div
                className="box-content"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  flexWrap: "nowrap",
                }}
              >
                <HeaderTitle
                  divStyle="header-div--sub"
                  headerStyle="header--sub"
                  headerSize="header--small"
                  headerColor="header--color"
                  divAlign="header--left"
                  textContent="Filtered Guidelines"
                ></HeaderTitle>

                <RichTextBox
                  isOpen={isModalOpenFilteredGuidelines}
                  onClose={() => {
                    setIsModalOpenFilteredGuidelines(false);
                  }}
                  text={filteredGuidelines}
                  setText={setFilteredGuidelines}
                  type="Modal"
                  hanger={"Summary"}
                >
                  text={props.guidelines.guideline_summary}
                  taskStatus={props.taskStatus}
                  hanger={"Summary"}
                  taskID={props.ocrData.Task_ID}
                </RichTextBox>
              </div>
            </form>
          </div>
        }
      />

      <PopOutModal
        widthTo="85%"
        isSmall="true"
        bigPopUpHeight={false}
        heightPopUp="90%"
        isOpen={isModalOpenClinicalSummary}
        onClose={() => {
          setIsModalOpenClinicalSummary(false);
        }}
        content={
          <>
            <div className="halfbox-content-new">
              <form>
                <div className="box-content" style={{ overflowY: "unset" }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <HeaderTitle
                      divStyle="header-div--sub"
                      headerStyle="header--sub"
                      headerSize="header--medium"
                      headerColor="header--color"
                      divAlign="header--left"
                      textContent="Clinical Summary"
                    ></HeaderTitle>
                  </div>

                  {loadingGenAI && (
                    <Box className="loader-wrapper">
                      <div className="loader"></div>
                    </Box>
                  )}
                  {/* {!loadingGenAI &&
                    dataForAIModel[selectedOption]?.["data"] != null &&
                    renderRichText()} */}

                  {((!loadingGenAI &&
                    dataForAIModel[selectedOption] == undefined) ||
                    !(
                      dataForAIModel[selectedOption] !== undefined &&
                      dataForAIModel[selectedOption]?.["error"] != null
                    )) &&
                    renderRichText()}
                </div>
              </form>
            </div>
            <div
              style={{
                textAlign: "center",
                margin: "40px",
                fontWeight: "400",
                fontSize: "large",
              }}
            >
              {dataForAIModel[selectedOption]?.["error"] != null && (
                <>
                  <div> {dataForAIModel[selectedOption]?.["error"]}</div>
                  <div>Do you want to Retry</div>
                  <div>
                    <button
                      class="btn btn-primary"
                      style={{ margin: "10px" }}
                      onClick={(e) => {
                        sendRefreshRequest();
                      }}
                    >
                      Yes
                    </button>
                    <button class="btn btn-primary" style={{ margin: "10px" }}>
                      No
                    </button>
                  </div>
                </>
              )}
            </div>
          </>
        }
      />
    </>
  );
};
